// extracted by mini-css-extract-plugin
export default {"userProfile":"user-profile_userProfile__+2AmE","txt":"user-profile_txt__--mef"};